/* hs-eslint ignored failing-rules */

/* eslint-disable promise/catch-or-return */
'use es6';

import quickFetch from 'quick-fetch';
import { from } from 'rxjs/observable/from';
import { buildErrorResponse } from 'hub-http/adapters/adapterUtils';
import { responseError } from 'hub-http/helpers/response';
export default (({
  retryRequester,
  name,
  wrapInObservable = true
}) => {
  const earlyMetaRequest = quickFetch.getRequestStateByName(name);

  if (!earlyMetaRequest) {
    if (retryRequester) {
      const retryPromise = retryRequester();
      return wrapInObservable ? from(retryPromise) : retryPromise;
    }

    return null;
  }

  const earlyRequestPromise = new Promise((resolve, reject) => {
    earlyMetaRequest.whenFinished(result => {
      resolve(result);
      quickFetch.removeEarlyRequest(name);
    });
    earlyMetaRequest.onError((xhr, errorCode) => {
      quickFetch.removeEarlyRequest(name);

      if (retryRequester) {
        retryRequester().then(resolve, reject);
      } else {
        const errorReponse = buildErrorResponse(xhr, `early request '${name}' failed`, errorCode);
        reject(responseError(errorReponse, `early request '${name}' failed`, errorCode));
      }
    });
  });
  return wrapInObservable ? from(earlyRequestPromise) : earlyRequestPromise;
});